<!-- Toast global -->
<p-toast position="top-right"></p-toast>
<p-confirmDialog></p-confirmDialog>

<!-- Loading -->
<div *ngIf="loading" class="flex justify-content-center align-items-center" style="min-height: 300px;">
  <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"></p-progressSpinner>
</div>

<!-- Conteudo de gestao -->
<div *ngIf="!loading" class="gestao-container">

  <!-- Header da gestao -->
  <app-cardapio-minishop-header
    [bannerUrl]="bannerUrl"
    [logoUrl]="logoUrl"
    [nomeNegocio]="nomeNegocio"
    (buscar)="termoBusca = $event"
    (trocarBanner)="onVerMenu()">
  </app-cardapio-minishop-header>

  <!-- Lista de categorias e produtos -->
  <div class="gestao-content">
    <app-cardapio-minishop-categoria-list
      [categorias]="categorias"
      [termoBusca]="termoBusca"
      [moedaSimbolo]="moedaSimbolo"
      [moedaLocal]="moedaLocal"
      (categoriaReordenada)="onCategoriaReordenada($event)"
      (produtoReordenado)="onProdutoReordenado($event)"
      (editarProduto)="onEditarProduto($event)"
      (novoProduto)="onNovoProduto($event)"
      (editarCategoria)="onEditarCategoria($event)"
      (excluirCategoria)="onExcluirCategoria($event)"
      (toggleVisibilidadeProduto)="onToggleVisibilidadeProduto($event)"
      (excluirProduto)="onExcluirProduto($event)">
    </app-cardapio-minishop-categoria-list>
  </div>

  <!-- Footer da gestao -->
  <app-cardapio-minishop-footer
    (verMenu)="onVerMenu()"
    (qrLinks)="onVerMenu()">
  </app-cardapio-minishop-footer>

</div>

<!-- Sidebar de edicao de produto (com variantes e modificadores) -->
<app-cardapio-minishop-produto-edit
  [(visivel)]="sidebarProdutoVisivel"
  [produto]="produtoSelecionado"
  [categoriaId]="categoriaSelecionadaId"
  [moedaSimbolo]="moedaSimbolo"
  [moedaLocal]="moedaLocal"
  [salvando]="salvandoProduto"
  (salvar)="onSalvarProduto($event)"
  (cancelar)="onCancelarEdicaoProduto()">
</app-cardapio-minishop-produto-edit>
